import { render, staticRenderFns } from "./PopupMenu.vue?vue&type=template&id=a63f8746&scoped=true"
import script from "./PopupMenu.vue?vue&type=script&lang=js"
export * from "./PopupMenu.vue?vue&type=script&lang=js"
import style0 from "./PopupMenu.vue?vue&type=style&index=0&id=a63f8746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63f8746",
  null
  
)

export default component.exports